import { SquarePlusIcon } from "@/shared/icons";
import { SoundButton } from "@/shared/ui";

export default function PlayerMenuTopUpBalance() {
  return (
    <div className="px-10 mt-2">
      <SoundButton className="flex items-center gap-2.5 w-full">
        <SquarePlusIcon size={16} />
        ПОПЛНИТЬ БАЛАНС
      </SoundButton>
    </div>
  );
}
